import { useState } from 'react';
import {ChevronLeft, ChevronRight } from 'lucide-react';


export default function Carousel({ item }) {
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);

    const nextImage = () => {
    	setCurrentImageIndex((prev) =>
        	prev === item.photoUrls.length - 1 ? 0 : prev + 1
    	);
    };

    const prevImage = () => {
      setCurrentImageIndex((prev) =>
        prev === 0 ? item.photoUrls.length - 1 : prev - 1
      );
    };

    const minSwipeDistance = 50

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
      setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
      if (!touchStart || !touchEnd) return;

      const distance = touchStart - touchEnd;
      const isLeftSwipe = distance > minSwipeDistance;
      const isRightSwipe = distance < -minSwipeDistance;

      if (isLeftSwipe) {
        nextImage();
      } else if (isRightSwipe) {
        prevImage();
      }
    };

  return (
  	<>
       <div
         className="relative w-full h-64 bg-gray-100 dark:bg-gray-600"
         onTouchStart={onTouchStart}
         onTouchMove={onTouchMove}
         onTouchEnd={onTouchEnd}
       >
         <img
           src={item.photoUrls[currentImageIndex]}
           alt={`${item?.title} - Image ${currentImageIndex + 1}`}
           className="w-full h-full object-cover"
         />

         { item.photoUrls.length > 1 && (
           <>
             <button
               onClick={ prevImage }
               className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
               aria-label="Previous image"
             >
               <ChevronLeft className="h-5 w-5" />
             </button>
             <button
               onClick={ nextImage }
               className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
               aria-label="Next image"
             >
               <ChevronRight className="h-5 w-5" />
             </button>

             <div className="absolute bottom-2 right-2 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
               { currentImageIndex + 1} / {item.photoUrls.length }
             </div>

             <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex space-x-2">
                { item.photoUrls.map((_, index) => (
                   <button
                     key={index}
                     onClick={() => setCurrentImageIndex(index)}
                     className={`h-2 w-2 rounded-full transition-all ${
                       index === currentImageIndex
                        ? 'bg-white w-6'
                        : 'bg-white/50 hover:bg-white/75'
                      }`}
                     aria-label={`Go to image ${index + 1}`}
                   />
                ))}
             </div>
           </>
         )}
       </div>
    </>
  );
}
